var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02357 4.82855C5.02414 4.72746 5.00532 4.62725 4.96821 4.53367C4.93109 4.44008 4.8764 4.35496 4.80727 4.28319L1.82387 1.21076C1.68342 1.06612 1.49293 0.984863 1.29431 0.984863C1.09569 0.984863 0.905205 1.06612 0.764758 1.21076C0.624312 1.3554 0.54541 1.55157 0.54541 1.75611C0.54541 1.96066 0.624312 2.15683 0.764758 2.30147L3.22607 4.82855L0.772217 7.35563C0.650027 7.50257 0.586177 7.69158 0.593428 7.88489C0.600678 8.07821 0.678495 8.26159 0.811327 8.39838C0.944159 8.53518 1.12222 8.61532 1.30994 8.62278C1.49765 8.63025 1.68118 8.5645 1.82387 8.43866L4.80727 5.36623C4.94506 5.22316 5.02275 5.03005 5.02357 4.82855Z",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDark);
export default __webpack_public_path__ + "static/media/chevron-right-dark.6290afc87952602f98137cf846036780.svg";
export { ForwardRef as ReactComponent };